import {Mixin} from "mixwith/mixwith";

let ClassPlaceholderMixin = null;
export let PlaceholderMixin = Mixin((superclass) => {
    ClassPlaceholderMixin = class extends superclass {
        constructor() {
            super(...arguments);
            this._placeholder = null;
        }

        placeholder(value) {
            this._placeholder = value;
            return this;
        }
    }
    return ClassPlaceholderMixin
});

export {ClassPlaceholderMixin}
